import { useMemo } from "react";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import { useTranslation } from "react-i18next";
import { useBrand } from "../../context/BrandContext";
import defaultAppLogo from "../../assets/smarttt-default-logo.png";
import { resolveClubImageUrl } from "../../utils/resolveClubImageUrl";
import { clearLocalStoragePreservingBrand } from "../../utils/localStorageBrand";
import { getHomeRolesFromUser, readStoredUser } from "../../utils/homeRole";
import { isSuperAdminUser } from "../../utils/brandAuth";
import { LanguageShortcutFab } from "../LanguageShortcutFab";
import { disconnectSocket } from "../../socket";

import { openSwitchClubDialog } from "../../utils/switchActiveClubClient";

export function TopBar() {
  const { t } = useTranslation();
  const { brand, refreshBrand } = useBrand();
  const logoSrc = resolveClubImageUrl(brand?.logo_url) || defaultAppLogo;
  const brandName = brand?.brand_name || brand?.brand_short_name || "Club";

  const showHome = useMemo(() => {
    const user = readStoredUser() || {};
    const roles = getHomeRolesFromUser(user);
    if (roles.includes("moderator")) return true;
    const isAdmin =
      isSuperAdminUser(user) ||
      roles.includes("admin") ||
      Number(user.type_user_id) === 1 ||
      Number(user.type_user_id) === 2;
    if (!isAdmin) return true;
    return roles.includes("coach") || roles.includes("player");
  }, []);

  const handleBrandClick = (e) => {
    const user = readStoredUser() || {};
    const isAdminOrCoach =
      Number(user.type_user_id) === 2 ||
      Number(user.type_user_id) === 3 ||
      Number(user.type_user_id) === 6 ||
      user.hasAdminRole ||
      user.hasCommitteeRole ||
      user.hasCoachRole ||
      user.hasModeratorRole ||
      isSuperAdminUser(user);
    if (isAdminOrCoach) {
      e.preventDefault();
      e.stopPropagation();
      openSwitchClubDialog();
    }
  };

  return (
    <div id="topBar">
      <NavLink
        to="/Dashboard"
        className="topbar-club-brand"
        title={t("switchClubPrompt", "Switch club") || brandName}
        onClick={handleBrandClick}
        style={{ cursor: "pointer" }}
      >
        <img src={logoSrc} alt="" className="topbar-club-logo" />
        <span className="topbar-club-name">{brandName}</span>
      </NavLink>
      <ul>
        <li className="topbar-lang">
          <LanguageShortcutFab variant="inline" />
        </li>
        {showHome ? (
          <li>
            <NavLink to="/home" title={t("home") || "Home"}>
              <HomeIcon />
            </NavLink>
          </li>
        ) : null}
        <li>
          <NavLink
            to="/login"
            onClick={() => {
              clearLocalStoragePreservingBrand();
              sessionStorage.clear();
              disconnectSocket();
              void refreshBrand?.();
            }}
          >
            <FontAwesomeIcon icon={faSignOutAlt} /> {t("logout")}
          </NavLink>
        </li>
      </ul>
    </div>
  );
}
